import { OpenSearchService } from "common/search/services/OpenSearchService";

export class ReserveStorageOutboundsSearchService extends OpenSearchService {}
